import { Link, NavLink, Outlet } from 'react-router-dom'
import { SiteNotice } from './components/SiteNotice'
import { useSeo } from './hooks/useSeo'

function App() {
  useSeo()
  return (
    <div className="page">
      <SiteNotice />
      <header className="header">
        <div className="container header__inner">
          <NavLink to="/" className="brand" aria-label="Stratum Labs — home">
            <img
              className="brand__logo"
              src="/brand/stratum-labs-logo-dark.svg"
              alt="Stratum Labs"
            />
          </NavLink>
          <nav className="nav" aria-label="Primary">
            <NavLink to="/" end>
              Home
            </NavLink>
            <NavLink to="/services">Services</NavLink>
            <NavLink to="/products">Products</NavLink>
            <NavLink to="/contact">Contact</NavLink>
          </nav>
        </div>
      </header>

      <main>
        <Outlet />
      </main>

      <footer className="footer">
        <div className="container footer__inner">
          <span>
            <span className="footer__brand">Stratum Labs</span> &copy; {new Date().getFullYear()}.
            All rights reserved.
          </span>
          <nav className="footer__links" aria-label="Footer">
            <Link to="/services">Services</Link> · <Link to="/products">Products</Link> ·{' '}
            <Link to="/contact">Contact</Link> · <Link to="/privacy">Privacy</Link>
          </nav>
        </div>
      </footer>
    </div>
  )
}

export default App
